import {createContext, useEffect, useRef, useState} from 'react';
import Preloader from "../../Preloader";

export interface PreloaderContextType {
    setLoading: (loading: boolean) => void
}

export const PreloaderContext = createContext<any>(null);

export const PreloaderContextProvider = (props: any) => {
    const [renderLoading, setRenderLoading] = useState(true);
    const [rerender, setRerender] = useState(new Date().getTime())
    const loadingElementsCountRef = useRef(0);

    const setLoading = (flag: boolean) => {
        if (flag) loadingElementsCountRef.current = loadingElementsCountRef.current + 1
        else loadingElementsCountRef.current = loadingElementsCountRef.current - 1;
        const dateNow = Date.now();
        setRerender(dateNow);
    }

    useEffect(() => {
        if (loadingElementsCountRef.current > 0) setRenderLoading(true);
        if (loadingElementsCountRef.current <= 0) {
            setRenderLoading(false);
            loadingElementsCountRef.current = 0;
        }

    }, [rerender]);

    const clearBlur = () => {
        const root = document.getElementById("root");
        if (root) {
            root.childNodes.forEach(el => {
                if (el instanceof HTMLElement) {
                    el.style.filter = "";
                }
            });
        }

        return null;
    };

    return <>
        <PreloaderContext.Provider value={{setLoading}}>
            {
                renderLoading ?
                    <Preloader/>
                    :
                    clearBlur()
            }
            {props.children}
        </PreloaderContext.Provider>
    </>
};
